import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SaveButton } from '@lib/core/src';
import JourneyLogo from '@lib/core/src/assets/logo/journey-logo-black.svg?react';
import palette from '@lib/core/src/theme/palette';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Fade, Grow, Slide, Typography } from '@mui/material';
import { Box } from '@mui/system';

import HomeIcon from '@/assets/buttons-icons/home.svg?react';
import RoutesMap from '@/enums/RoutesMap';

import { PageContainer } from './ErrorBoundaryStyles';

const ErrorBoundaryPage: React.FC<{ onBackToHome: () => void }> = ({ onBackToHome }) => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Fade in timeout={800}>
        <Box sx={{ position: 'absolute', top: '38px', left: '57px' }}>
          <JourneyLogo width="90px" />
        </Box>
      </Fade>
      <Box textAlign="center">
        <Slide direction="down" in timeout={600}>
          <SentimentVeryDissatisfiedIcon
            sx={{ fontSize: '80px', color: palette.grey[600], marginBottom: '12px' }}
          />
        </Slide>
        <Slide direction="down" in timeout={600}>
          <Typography
            sx={{ fontSize: '24px', fontWeight: 600, color: palette.black, marginBottom: '12px' }}
          >
            Oops! Something went wrong.
          </Typography>
        </Slide>
        <Fade in timeout={1000}>
          <Typography sx={{ fontSize: '13px', color: palette.grey[500] }}>
            We are on it and we will get it fixed as soon as we can.
          </Typography>
        </Fade>
        <Box
          sx={{
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Grow in timeout={800}>
            <SaveButton
              sx={{
                flexDirection: 'row',
                gap: '4px',
                borderRadius: '20px',
                height: 'auto',
                width: 'auto',
                padding: '12px 15px'
              }}
              onClick={() => {
                onBackToHome();
                navigate(RoutesMap.Home);
              }}
            >
              <HomeIcon /> Back to home
            </SaveButton>
          </Grow>
        </Box>
      </Box>
    </PageContainer>
  );
};

export default ErrorBoundaryPage;
